import { DONATION_ROUTES, ROUTES } from './routes';

export type PartnerEntry =
  { kind: 'pass' } | { kind: 'redirect'; pathname: string };

//* `/.well-known/apple-app-site-association`처럼 확장자가 없는 정적 파일이 있어 디렉토리 접두사도 함께 본다.
const STATIC_PATH_PREFIXES: readonly string[] = [
  '/assets',
  '/_next',
  '/.well-known',
];

const STATIC_FILE_EXTENSION =
  /\.(js|css|png|jpg|jpeg|gif|svg|ico|woff|woff2|ttf|eot|json|txt|xml|webmanifest)$/i;

export const matchesPrefix = (pathname: string, prefix: string) =>
  pathname === prefix || pathname.startsWith(`${prefix}/`);

export const isStaticPath = (pathname: string) =>
  STATIC_PATH_PREFIXES.some((prefix) => matchesPrefix(pathname, prefix)) ||
  pathname.includes('/favicon') ||
  STATIC_FILE_EXTENSION.test(pathname);

export const toDonationPath = (pathname: string) =>
  pathname === ROUTES.HOME.pathname
    ? DONATION_ROUTES.HOME.pathname
    : `${DONATION_ROUTES.HOME.pathname}${pathname}`;
